import { matchQuery } from '@gogame/query';

import { grids, chart } from '../../queryKeyFactory';

export const customMetricsPredicate = (query, name) => {
  const params =
    Array.isArray(query.queryKey) && query.queryKey.slice(-1).pop();

  if (matchQuery({ queryKey: grids }, query)) {
    return params?.columns.order.includes(name);
  }

  if (
    params &&
    matchQuery(
      { ...query },
      {
        queryKey: chart(params),
      }
    )
  ) {
    return params.metrics?.includes(name);
  }
  return false;
};
